var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7844 16.1121C21.053 16.111 21.3109 16.2169 21.5011 16.4064C21.6914 16.5959 21.7984 16.8533 21.7984 17.1219V18.6674C21.7984 20.5079 20.3063 22 18.4657 22H5.32847C3.48953 21.9977 2 20.5063 2 18.6674V17.1219C2 16.5642 2.4521 16.1121 3.00979 16.1121C3.56748 16.1121 4.01958 16.5642 4.01958 17.1219V18.6674C4.0205 19.3897 4.60611 19.975 5.32847 19.9754H18.4657C19.1881 19.975 19.7737 19.3897 19.7746 18.6674V17.1219C19.7746 16.5642 20.2267 16.1121 20.7844 16.1121Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5072 17.3608C12.3538 17.5376 12.1313 17.6392 11.8973 17.6392C11.6633 17.6392 11.4408 17.5376 11.2874 17.3608L7.24827 12.7151C7.04075 12.4762 6.99183 12.1381 7.12309 11.8501C7.25435 11.5621 7.54165 11.3772 7.85814 11.3771H10.0735C10.1885 11.3771 10.2818 11.2838 10.2818 11.1688V3.61536C10.2818 2.72314 11.0051 1.99986 11.8973 1.99986C12.7895 1.99986 13.5128 2.72314 13.5128 3.61536V11.1688C13.5128 11.2838 13.6061 11.3771 13.7211 11.3771H15.9365C16.253 11.3772 16.5402 11.5621 16.6715 11.8501C16.8028 12.1381 16.7538 12.4762 16.5463 12.7151L12.5072 17.3608Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/Download2.de0df37b529eaeddaa6550635ffcfa10.svg";
export { ForwardRef as ReactComponent };